import { render, staticRenderFns } from "./ListItemImgCarousel.vue?vue&type=template&id=236c213c&scoped=true&"
import script from "./ListItemImgCarousel.vue?vue&type=script&lang=js&"
export * from "./ListItemImgCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ListItemImgCarousel.vue?vue&type=style&index=0&id=236c213c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236c213c",
  null
  
)

export default component.exports